module.exports = __webpack_public_path__ + "static/am-logo-a5d444da55723a539a4738df320adc6c.png";